import { Sparkles } from "lucide-react";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 md:py-32">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="overline mb-6 flex items-center gap-3">
          <Sparkles size={14} />
          <span>// THE_STORY</span>
        </div>

        <h2 className="font-heading font-black text-4xl md:text-5xl lg:text-6xl tracking-tighter mb-8 leading-[1.05]">
          Years of work.<br />
          One <span className="text-neon-orange neon-text-orange">honest</span> blueprint.
        </h2>

        <div className="space-y-5 text-white/70 text-base md:text-lg leading-relaxed">
          <p>
            Techsavvypreneurs wasn&apos;t built overnight. It came from years of doing the work — the wins, the lessons, and everything in between. <span className="text-white">Real ventures. Real outcomes.</span>
          </p>
          <p>
            Today we run seven of them. From Walmart inventory to real estate to the markets — each one taught us the same thing: <span className="text-white">good systems, steady execution, and the right guidance compound quietly into real wealth.</span>
          </p>
          <p className="text-white/50 text-sm md:text-base">
            Whether you&apos;re just getting started or recalibrating after a setback — you&apos;ve found the right table.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-3 gap-6 pt-8 border-t border-white/10">
          {[
            { k: "Approach", v: "Honest. Patient. Direct." },
            { k: "Method", v: "Systems over hustle." },
            { k: "Outcome", v: "Income you can keep." },
          ].map((b) => (
            <div key={b.k}>
              <div className="overline mb-2 text-neon-cyan/80">// {b.k}</div>
              <div className="text-sm text-white/80">{b.v}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
